const flaggedContentES = {
    "view": {
        "form": {
            "button": {
                "viewDetails": "Ver Detalles"
            },
            "message": {
                "releaseHasBeenAddedToWhitelist": "El lanzamiento <strong>{{releaseName}}</strong> ha sido añadido a la lista blanca.",
                "releaseHasFlaggedContent": "El lanzamiento <strong>{{releaseName}}</strong> contiene pistas marcadas. Se aplica una tarifa de <strong>15 €</strong> por pista marcada para entregarla a <strong>Spotify</strong>.<br/><br/> Haz clic en el botón de abajo para completar tu pago y continuar."
            },
            "modal": {
                "header": {
                    "titleFlaggedTracksDetails": "Detalles de Pistas Marcadas",
                    "titleFlaggedTrackPayment": "Pago de Lista Blanca de Spotify"
                },
                "body": {
                    "table": {
                        "title": "Las siguientes pistas han sido marcadas. Por favor, revisa los detalles a continuación:",
                        "column": {
                            "name": "Nombre de la Pista",
                            "flaggedArtist": "Artista Marcado",
                            "payableAmount": "Monto a Pagar",
                            "paymentStatus": "Estado del Pago"
                        },
                        "label": {
                            "payableAmount": "15 €",
                            "paid": "PAGADO",
                            "pending": "PENDIENTE",
                        },
                    },
                    "label": {
                        "processingPayment": "Procesando Pago...",
                        "paymentSuccessful": "¡Pago Exitoso!",
                        "paymentFailed": "¡Pago Fallido!"
                    },
                    "message": {
                        "totalPayableAmount": "Para completar la entrega de tu lanzamiento a <strong>Spotify</strong>, se requiere un depósito reembolsable de <strong>{{totalAmount}} €</strong>. Por favor, acepta los términos a continuación y haz clic en el botón <strong>Proceder</strong> para realizar tu pago.",
                        "escrowAmountAgreement": "Acepto y reconozco que un monto en depósito de <strong>{{totalAmount}} €</strong> será depositado por mí. Este monto se mantendrá hasta el <strong>final de la suscripción</strong> y, siempre que no surjan problemas, se me devolverá al final de este período. Sin embargo, si violo los términos de este acuerdo durante este tiempo, el monto en depósito se aplicará a la factura pendiente y no será reembolsado. Al proceder, afirmo mi comprensión y aceptación de estas condiciones.",
                        "escrowPaymentRejected": "No acepto los términos del pago en depósito y, en consecuencia, reconozco que mi lanzamiento <strong>{{releaseName}}</strong> <strong>no será distribuido a Spotify</strong>.",
                        "consentRecordedSuccessfully": "¡Consentimiento Registrado Exitosamente!"
                    }
                },
                "button": {
                    "proceed": "Proceder"
                }
            }
        }
    }
}

export default flaggedContentES;